import React, { Component } from "react";
import "../App.css";

import { DatePickerComp } from "../components/DatePickerComp";
import { FetchButton } from "../components/FetchButton";

import DropDownSensors from "./DropDownSensors";
import DropDownRollUp from "./DropDownRollUp";
import DropDownFunctions from "./DropDownFunctions";
import D3chart from "./D3chart";
import { connect } from "react-redux";
import { fetchData, setFromDate, setToDate } from "../actions/scActions";

class Home extends Component {
  componentWillMount() {
    this.fetch();
  }

  dropDownchange(datum, src) {
    if (src === "dpFrom") {
      this.props.fromDate(datum);
    } else {
      this.props.toDate(datum);
    }
  }

  fetch() {
    let sid = this.props.sc.sensorId;
    let rollup = this.props.sc.rollUp;
    let functie = this.props.sc.functionId;
    let from = this.props.sc.fromDate;
    let to = this.props.sc.toDate;

    this.props.fetchReadings(sid, rollup, functie, from, to);
  }

  render() {
    return (
      <div>
        <h4>
          Please note this application is currently not tracking. Please use
          historic data, for example from September 2017.
        </h4>
        <h1>Sensor Data</h1>
        <div className="row">
          <DatePickerComp
            label="From"
            datum={this.props.sc.fromDate}
            changeDP={(datum) => this.dropDownchange(datum, "dpFrom")}
          />
          <DatePickerComp
            label="To"
            datum={this.props.sc.toDate}
            changeDP={(datum) => this.dropDownchange(datum, "dpTo")}
          />
          <DropDownSensors />
        </div>
        <div className="row">
          <DropDownRollUp />
          <DropDownFunctions />
        </div>
        <div className="row">
          <FetchButton clickSubmit={() => this.fetch()} />
        </div>
        <div className="row">
          <div className="col-sm-12">
            <D3chart />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    sc: state.scReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReadings: (sid, rollup, functie, from, to) => {
      dispatch(fetchData(sid, rollup, functie, from, to));
    },
    fromDate: (datum) => {
      dispatch(setFromDate(datum));
    },
    toDate: (datum) => {
      dispatch(setToDate(datum));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js